import { JSEncrypt } from 'jsencrypt';

/**
 * Converts a Base64 value to hexadecimal.
 */
const base64ToHex = (value: string): string => {
  const binaryValue = window.atob(value);

  return Array.from(binaryValue)
    .map((character: string): string =>
      character.charCodeAt(0).toString(16).padStart(2, '0'),
    )
    .join('');
};

/**
 * Encrypts an email address for the Bazaarvoice transaction event.
 */
const encryptReviewRequestEmail = (email: string, publicKey: string): string => {
  const encryptor = new JSEncrypt();
  encryptor.setPublicKey(publicKey);
  const encryptedEmail = encryptor.encrypt(email);

  if (!encryptedEmail) {
    throw new Error('Unable to encrypt the review-request email.');
  }

  return base64ToHex(encryptedEmail);
};

export default encryptReviewRequestEmail;
